export const ratesMonthData = [
    [5.743343, 10.743343, 20.743343],
    [5.743343, 20.743343, 10.743343],
    [10.743343, 5.743343, 20.743343],
    [10.743343, 20.743343, 5.743343],
    [20.743343, 5.743343, 10.743343],
    [20.743343, 10.743343, 5.743343],
    [5.743343, 10.743343, 20.743343],
    [5.743343, 20.743343, 10.743343],
    [10.743343, 5.743343, 20.743343],
    [10.743343, 20.743343, 5.743343],
    [20.743343, 5.743343, 10.743343],
    [20.743343, 10.743343, 5.743343],
    [5.743343, 10.743343, 20.743343],
    [5.743343, 20.743343, 10.743343],
    [10.743343, 5.743343, 20.743343],
    [10.743343, 20.743343, 5.743343],
    [20.743343, 5.743343, 10.743343],
    [20.743343, 10.743343, 5.743343],
    [5.743343, 10.743343, 20.743343],
    [5.743343, 20.743343, 10.743343],
    [10.743343, 5.743343, 20.743343],
    [10.743343, 20.743343, 5.743343],
    [20.743343, 5.743343, 10.743343],
    [20.743343, 10.743343, 5.743343],
    [5.743343, 10.743343, 20.743343],
    [5.743343, 20.743343, 10.743343],
    [10.743343, 5.743343, 20.743343],
    [10.743343, 20.743343, 5.743343],
    [20.743343, 5.743343, 10.743343],
    [20.743343, 10.743343, 5.743343],
    [5.743343, 10.743343, 20.743343],
];

export const ratesData = [
    { monthName: 'Januari', data: ratesMonthData.slice(0, 31) },
    { monthName: 'Febuari', data: ratesMonthData.slice(0, 28) },
    { monthName: 'Maart', data: ratesMonthData.slice(0, 31) },
    { monthName: 'April', data: ratesMonthData.slice(0, 30) },
    { monthName: 'Mei', data: ratesMonthData.slice(0, 31) },
    { monthName: 'Juni', data: ratesMonthData.slice(0, 30) },
    { monthName: 'Juli', data: ratesMonthData.slice(0, 31) },
    { monthName: 'Augustus', data: ratesMonthData.slice(0, 31) },
    { monthName: 'September', data: ratesMonthData.slice(0, 30) },
    { monthName: 'Oktober', data: ratesMonthData.slice(0, 31) },
    { monthName: 'November', data: ratesMonthData.slice(0, 30) },
    { monthName: 'December', data: ratesMonthData.slice(0, 31) },
];

export const monthlyReturns = [
    { year: '2021', returns: [3.21, 1.31, -2.41, 6.51, 4.61, 2.71, -4.81, 3.91, 5.11, 1.21, -4.31, 3.41, 20.71] },
    { year: '2020', returns: [3.31, 2.21, -1.31, 6.41, 4.51, 2.61, -4.71, 3.81, 1.91, 5.11, -4.21, 3.31, 20.61] },
    { year: '2019', returns: [3.41, 1.31, -6.21, 2.31, 4.41, 2.51, -4.61, 3.71, 5.81, 4.91, -1.11, 3.21, 20.51] },
    { year: '2018', returns: [3.51, 1.41, -2.31, 4.21, 6.31, 2.41, -4.51, 3.61, 5.71, 1.81, -3.91, 4.11, 20.41] },
    { year: '2017', returns: [3.61, 1.51, -2.41, 6.31, 2.21, 4.31, -4.41, 3.51, 5.61, 1.71, -4.81, 3.91, 20.31] },
    { year: '2016', returns: [3.71, 1.61, -2.51, 6.41, 4.31, 4.21, -2.31, 3.41, 5.51, 1.61, -4.71, 3.81, 20.21] },
    { year: '2015', returns: [3.81, 1.71, -2.61, 6.51, 4.41, 2.31, -3.21, 4.31, 5.41, 1.51, -4.61, 3.71, 20.21] },
    { year: '2014', returns: [3.91, 1.81, -2.71, 6.61, 4.51, 2.41, -4.31, 5.21, 3.31, 1.41, -4.51, 3.61, 20.31] },
    { year: '2013', returns: [3.11, 2.91, -1.81, 6.71, 4.61, 2.51, -4.41, 3.31, 1.21, 5.31, -4.41, 3.51, 20.41] },
    { year: '2012', returns: [3.21, 1.11, -6.91, 2.81, 4.71, 2.61, -4.51, 3.41, 5.31, 4.21, -1.31, 3.41, 20.51] },
    { year: '2011', returns: [3.31, 1.21, -2.11, 4.91, 6.81, 2.71, -4.61, 3.51, 5.41, 1.31, -3.21, 4.31, 20.61] },
    { year: '2010', returns: [3.41, 1.31, -2.21, 6.11, 2.91, 4.81, -4.71, 3.61, 5.51, 1.41, -4.31, 3.21, 20.71] },
];

export const titleRow = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
    'Jaar',
];

export const navMonthData = [
    31.01,
    30.02,
    29.03,
    28.04,
    27.05,
    26.06,
    25.07,
    24.08,
    23.09,
    22.1,
    21.11,
    20.12,
    19.13,
    18.14,
    17.15,
    16.16,
    15.17,
    14.18,
    13.19,
    12.2,
    11.21,
    10.22,
    9.23,
    8.24,
    7.25,
    6.26,
    5.27,
    4.28,
    3.29,
    2.3,
    1.31,
];

export const navData = [
    { monthName: 'Januari', data: navMonthData.slice(0, 31) },
    { monthName: 'Febuari', data: navMonthData.slice(0, 28) },
    { monthName: 'Maart', data: navMonthData.slice(0, 31) },
    { monthName: 'April', data: navMonthData.slice(0, 30) },
    { monthName: 'Mei', data: navMonthData.slice(0, 31) },
    { monthName: 'Juni', data: navMonthData.slice(0, 30) },
    { monthName: 'Juli', data: navMonthData.slice(0, 31) },
    { monthName: 'Augustus', data: navMonthData.slice(0, 31) },
    { monthName: 'September', data: navMonthData.slice(0, 30) },
    { monthName: 'Oktober', data: navMonthData.slice(0, 31) },
    { monthName: 'November', data: navMonthData.slice(0, 30) },
    { monthName: 'December', data: navMonthData.slice(0, 31) },
];
